import React from "react";
import { Box } from "@mantine/core";

const ThreadConnectionLine = ({ isMain, isLast }) => {
  return (
    <>
      {/* 연결선 (메인이 아닌 스레드일 때 위쪽으로 연결) */}
      {!isMain && (
        <Box
          style={{
            position: "absolute",
            left: "18px",
            top: "-24px",
            width: "2px",
            height: "24px",
            backgroundColor: "#e0e0e0",
            borderRadius: "1px",
            zIndex: 0
          }}
        />
      )}
      
      {/* 연결선 (다음 스레드가 있을 때 아래쪽으로 연결) */}
      {!isLast && (
        <Box
          style={{
            position: "absolute",
            left: "18px",
            top: "36px",
            width: "2px",
            height: "100%",
            backgroundColor: "#e0e0e0",
            borderRadius: "1px",
            zIndex: 0
          }}
        />
      )}
    </>
  );
};

export default ThreadConnectionLine; 